import { createRequest } from "helpers/tools";

export const getDaysTracker = async (dates) => {
    return await createRequest({
        suffix: `trackers/reports/events`,
        method: "post",
        payload: dates,
        handleError: false,
    });
};
